import { mobileLargeMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import Link from 'next/link';
import styled from 'styled-components';

export const Section = styled.section<{ noBg?: boolean }>`
  padding: 32px 0;
  border-top: 1px solid ${(props) => props.theme.backgroundLight};
  :first-child {
    border-top: none;
  }

  :nth-child(odd) {
    background: ${(props) => (props.noBg ? 'initial' : props.theme.backgroundLighter)};
  }

  @media screen and (${mobileLargeMax}) {
    h3 {
      font-size: 32px;
    }

    h4 {
      font-size: 20px;
    }
  }
`;

export const TwoColumn = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const TwoColumnBox = styled.div`
  width: 50%;
  @media screen and (${mobileLargeMax}) {
    width: 100%;
  }
`;

export const TwoColumnList = styled.ul`
  display: flex;
  flex-direction: column;
  list-style-type: none;
  padding: 0;
  margin: 30px 0;
  width: 100%;
`;

export const List = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  list-style-type: none;
  padding: 0;
  margin: 30px 0;
`;

export const ListItem = styled.li`
  width: 50%;
  text-decoration: underline;
  line-height: 1.4;

  &:hover {
    color: ${(props) => props.theme.backgroundLight};
    p {
      color: ${(props) => props.theme.backgroundLight};
    }
  }

  @media screen and (${tabletMax}) {
    width: 100%;
    line-height: 1.5em;
    padding-right: 20px;
    margin-bottom: 5px;

    p {
      font-size: 0.9em;
    }
  }
`;

export const LetterList = styled.ul`
  list-style-type: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  max-width: 75%;
`;

export const Letter = styled.li<{ isActive: boolean }>`
  text-decoration: ${(props) => (props.isActive ? 'underline' : 'none')};
  line-height: 1.8em;
  justify-self: center;
  padding: 0 10px;

  ${(props) =>
    props.isActive
      ? `&:hover {
    color: ${props.theme.backgroundLight};
    p {
      color: ${props.theme.backgroundLight};
    }
  }`
      : 'none'};

  border-right: 1px solid ${(props) => props.theme.backgroundLight};

  :last-child {
    border-right: none;
  }
`;

export const BackLink = styled(Link)`
  text-decoration: underline;
  text-decoration-color: ${(props) => props.theme.primary};

  &:hover {
    text-decoration-color: ${(props) => props.theme.backgroundLight};
    color: ${(props) => props.theme.backgroundLight};
    p {
      color: ${(props) => props.theme.backgroundLight};
    }
  }
`;
